import { app } from '../../app.module'
/**
 * CSVダウンロードボタン
 * @class CsvDownoadButtonCtrl
 */
class CsvDownoadButtonCtrl {
  private filename: string
  private loading: boolean
  private disabled: boolean
  private tooltip: string
  private downloadCsv: Function

  public $onInit() {
    if (this.loading !== true) {
      this.loading = false
    }
    if (this.disabled !== true) {
      this.disabled = false
    }
    if (!this.tooltip) {
      this.tooltip = 'CSVダウンロード'
    }
  }

  /**
   * CSVダウンロード
   */
  public download() {
    return this.downloadCsv()
  }
}

/**
 * CSVダウンロードボタン
 * attr: {string} filename ファイル名
 * attr: {boolean} loading ローディングフラグ
 * attr: {boolean} disabled disabledフラグ
 * attr: {string} tooltip ツールチップ
 * attr: {function} downloadCsv ダウンロードイベント
 */
app.component('csvDownloadButton', {
  bindings: {
    filename: '<',
    loading: '<',
    disabled: '<',
    tooltip: '@',
    downloadCsv: '&',
  },
  template: require('./csv-download-button.pug')(),
  controller: CsvDownoadButtonCtrl,
})
